import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import ContentHeader from '../../components/ContentHeader';
import axios from 'axios';
import $ from 'jquery';
import Swal from 'sweetalert2';
import Loader from "../../components/Loader";
import { Link } from 'react-router-dom';

const Permissions = () => {
    const { roleId } = useParams();
    const [loading, setLoading] = useState(false);
    const [roles, setRoles] = useState([]);
    const [rol_id, setRolId] = useState(roleId ? parseInt(roleId) : 0);
    const [permissions, setPermissions] = useState({});
    const [menuItems, setMenuItems] = useState([]);
    const ENDPOINT = process.env.REACT_APP_URL_ENDPOINT;
    const TITLEALERT = process.env.REACT_APP_TITLE_ALERT;

    useEffect(() => {
        getMenus();
        getRoles();
        if (roleId) {
            getRolePermissions(roleId);
        }
        setTimeout(() => {
            $('.select2').select2({
                width: '100%',
                placeholder: 'Seleccionar un rol',
            }).on('change', function (e) {
                setRolId(parseInt(e.target.value));
            });
        }, 100);
    }, [roleId]);

    const getMenus = async () => {
        await axios.get(ENDPOINT + "get-all-menus").then((response) => {
            setMenuItems(response.data.data);
        }).catch((error) => {
            console.log(error);
        });
    };

    const getRoles = async () => {
        const roleIdParam = roleId ? roleId : 0;
        const response = await axios.get(`${ENDPOINT}get-all-roles-permissions/${roleIdParam}`);
        const rolesArray = response.data.data.map(function (element) {
            return {
                label: element.name,
                value: element.rol_id,
            };
        });
        setRoles(rolesArray);
    };

    const getRolePermissions = async (roleId) => {
        setLoading(true);
        try {
            const response = await axios.get(`${ENDPOINT}get-role-permissions/${roleId}`);
            const rolePermissions = response.data.data;
            if (rolePermissions) {
                const newPermissions = {};
                rolePermissions.forEach(permission => {
                    newPermissions[permission] = true;
                });
                setPermissions(newPermissions);
            }
        } catch (error) {
            console.log(error);
        } finally {
            setLoading(false);
        }
    };

    const handleMenuChange = (menuIndex) => {
        const newPermissions = { ...permissions };
        const menu = menuItems[menuIndex];
        const isChecked = !newPermissions[menu.menu_id];
        
        newPermissions[menu.menu_id] = isChecked;
        
        if (menu.submenu && menu.submenu.length > 0) {
            menu.submenu.forEach(submenu => {
                newPermissions[submenu.menu_id] = isChecked;
            });
        }

        setPermissions(newPermissions);
    };

    const handleSubmenuChange = (menuIndex, submenuIndex) => {
        const newPermissions = { ...permissions };
        const menu = menuItems[menuIndex];
        const submenu = menu.submenu[submenuIndex];
        const isChecked = !newPermissions[submenu.menu_id];
        
        newPermissions[submenu.menu_id] = isChecked;
        
        if (isChecked) {
            newPermissions[menu.menu_id] = true;
        } else {
            const anySubmenuChecked = menu.submenu.some(
                sub => sub.menu_id !== submenu.menu_id && newPermissions[sub.menu_id]
            );
            newPermissions[menu.menu_id] = anySubmenuChecked;
        }

        setPermissions(newPermissions);
    };

    const handleSave = async () => {
        if (rol_id === 0) {
            Swal.fire({
                icon: "warning",
                title: '<div class="title-custom-alert">' + TITLEALERT + '</div>',
                html: '<div class="text-custom-alert">Debe seleccionar un rol</div>',
                showConfirmButton: true
            });
            return;
        }

        const selectedMenuIds = [];
        menuItems.forEach(menu => {
            if (permissions[menu.menu_id]) {
                selectedMenuIds.push(menu.menu_id);
            }
            if (menu.submenu) {
                menu.submenu.forEach(submenu => {
                    if (permissions[submenu.menu_id]) {
                        selectedMenuIds.push(submenu.menu_id);
                    }
                });
            }
        });

        if (selectedMenuIds.length === 0) {
            Swal.fire({
                icon: "warning",
                title: '<div class="title-custom-alert">' + TITLEALERT + '</div>',
                html: '<div class="text-custom-alert">Debe seleccionar al menos un permiso</div>',
                showConfirmButton: true
            });
            return;
        }

        setLoading(true);
        const form = new FormData();
        form.append('rol_id', rol_id);
        form.append('menus', JSON.stringify(selectedMenuIds));


        try {
            const response = await axios.post(ENDPOINT + 'save-permission', form);
            setLoading(false);
            Swal.fire({
                icon: "success",
                title: '<div class="title-custom-alert">' + TITLEALERT + '</div>',
                showConfirmButton: false,
                timer: 3000,
                html: '<div class="text-custom-alert">' + response.data.msg + "</div>",
                showClass: { popup: "animate__animated animate__fadeInDown" },
                hideClass: { popup: "animate__animated animate__fadeOutUp" },
            });
        } catch (error) {
            if (error.response && error.response.status === 409) { // Si el permiso ya existe
                try {
                    const updateResponse = await axios.put(ENDPOINT + 'update-permission', form);
                    setLoading(false);
                    Swal.fire({
                        icon: "success",
                        title: '<div class="title-custom-alert">' + TITLEALERT + '</div>',
                        showConfirmButton: false,
                        timer: 3000,
                        html: '<div class="text-custom-alert">' + updateResponse.data.msg + "</div>",
                        showClass: { popup: "animate__animated animate__fadeInDown" },
                        hideClass: { popup: "animate__animated animate__fadeOutUp" },
                    });
                } catch (updateError) {
                    console.log(updateError);
                    setLoading(false);
                    Swal.fire({
                        icon: "error",
                        title: '<div class="title-custom-alert">' + TITLEALERT + '</div>',
                        showConfirmButton: true,
                        html: '<div class="text-custom-alert">' + updateError.response.data.msg + "</div>",
                    });
                }
            } else {
                console.log(error);
                setLoading(false);
                Swal.fire({
                    icon: "error",
                    title: '<div class="title-custom-alert">' + TITLEALERT + '</div>',
                    showConfirmButton: true,
                    html: '<div class="text-custom-alert">' + error.response.data.msg + "</div>",
                });
            }
        }
    };

    const resetPage = () => {
        window.location.reload();
    };

    const getMenuDescription = (menuName) => {
        const descriptions = {
            "Dashboard": "Vista general de estadísticas y resumen del sistema",
            "Administración": "Gestión administrativa y configuraciones generales",
            "Empresas": "Administración de datos y perfiles empresariales",
            "Sucursales": "Gestión de ubicaciones y sedes de la empresa",
            "Socios": "Administración de socios comerciales y colaboradores",
            "Conductores": "Gestión del personal de conducción y licencias",
            "Destinos": "Control de rutas y destinos disponibles",
            "Horarios": "Programación y gestión de horarios de viajes",
            "Tipos de Unidades": "Configuración de categorías de vehículos",
            "Unidades": "Gestión de la flota de vehículos",
            "Letras": "Administración de documentos y comprobantes",
            "Boletas": "Gestión de tickets y comprobantes de viaje",
            "Boletos": "Control de venta y reserva de asientos",
            "Encomiendas": "Gestión de paquetes y envíos",
            "Reportes": "Generación de informes y análisis estadísticos",
            "Usuarios": "Administración de cuentas de usuario",
            "Roles": "Gestión de permisos y niveles de acceso",
            "Permisos": "Control de accesos y autorizaciones",
            "Configuración": "Ajustes generales del sistema",
            "Base de Datos": "Gestión y respaldo de información",
            "Caja": "Control de ingresos y movimientos financieros"
        };
        return descriptions[menuName] || "Gestión y control del módulo";
    };

    return (
        <>
            {loading && <Loader />}
            <div className="container-fluid">
                <ContentHeader title="Módulo de Permisos" />
            </div>
            <div className="container-fluid">
                <div className="card permissions-card">
                    <div className="card-header">
                        <div className="indications-header row">
                            <div className="col-md-7">
                                <h4 className="card-title m-0 page-title">
                                    <i className="bi bi-shield-lock me-2"></i> Permisos
                                </h4>
                            </div>
                            <div className="col-md-5" style={{ textAlign: "right" }}>
                                <Link
                                    to="/listado-permisos"
                                    className="btn btn-secondary btn-sm me-1">
                                    <i className="fas fa-list me-1"></i> Listado de Permisos
                                </Link>
                                <button
                                    onClick={resetPage}
                                    className="btn btn-info btn-sm me-1"
                                    type="button">
                                    <i className="fa fa-refresh me-1"></i> Recargar
                                </button>
                            </div>
                        </div>
                    </div>
                    <div className="card-body">
                        <div className="row mb-4">
                            <div className="col-md-6">
                                <div className="card permissions-card h-100">
                                    <div className="card-header">
                                        <h5 className="card-title m-0 page-title">
                                            <i className="bi bi-person-gear me-2"></i>
                                            Configuración de Rol
                                        </h5>
                                    </div>
                                    <div className="card-body d-flex flex-column">
                                        <div className="config-section">
                                            <div className="alert alert-primary alert-modern">
                                                <i className="bi bi-info-circle"></i>
                                                <strong>Seleccione los permisos para el rol correspondiente.</strong>
                                            </div>
                                            <div className="role-select-container">
                                                <label htmlFor="rol_id" className="form-label d-flex align-items-center mb-3">
                                                    <i className="bi bi-shield-lock me-2"></i>
                                                    <span>Seleccionar Rol</span>
                                                </label>
                                                <select
                                                    className="form-control form-control-sm select2"
                                                    id="rol_id"
                                                    name="rol_id"
                                                    value={rol_id}
                                                    onChange={(e) => setRolId(parseInt(e.target.value))}
                                                    required
                                                    disabled={!!roleId} // Deshabilitar si roleId está presente
                                                >
                                                    <option value="0">Seleccionar un rol</option>
                                                    {roles.map((item, index) => (
                                                        <option
                                                            key={index}
                                                            value={item.value}>
                                                            {item.label}
                                                        </option>
                                                    ))}
                                                </select>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-6">
                                <div className="card permissions-summary-card h-100">
                                    <div className="card-header">
                                        <h5 className="card-title m-0 page-title">
                                            <i className="bi bi-list-check me-2"></i>
                                            Resumen de Permisos
                                        </h5>
                                    </div>
                                    <div className="card-body d-flex flex-column">
                                        <div className="summary-section">
                                            <div className="summary-stats">
                                                <div className="stat-item">
                                                    <div className="stat-label">
                                                        <i className="bi bi-person-badge"></i>
                                                        <span>Rol Actual</span>
                                                    </div>
                                                    <div className="stat-value">
                                                        <span className="badge bg-primary">
                                                            {roles.find(role => role.value === rol_id)?.label || 'Ninguno'}
                                                        </span>
                                                    </div>
                                                </div>
                                                <div className="stat-item">
                                                    <div className="stat-label">
                                                        <i className="bi bi-check2-square"></i>
                                                        <span>Permisos</span>
                                                    </div>
                                                    <div className="stat-value">
                                                        <span className="badge bg-success">
                                                            {Object.keys(permissions).filter(key => permissions[key]).length}
                                                        </span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="actions-section mt-auto align-self-end">
                                            <button 
                                                className="btn btn-sm btn-success btn-save" 
                                                onClick={handleSave}
                                            >
                                                <i className="fa-solid fa-floppy-disk me-1"></i>
                                                {roleId ? "Actualizar Permisos" : "Guardar Permisos"}
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        
                        <div className="permissions-menu">
                            {menuItems.map((menu, menuIndex) => (
                                <div key={menuIndex} className="permissions-menu-item">
                                    <div className="permissions-menu-header">
                                        <input
                                            type="checkbox"
                                            className="styled-checkbox"
                                            id={`menu-${menu.menu_id}`}
                                            checked={permissions[menu.menu_id] || false}
                                            onChange={() => handleMenuChange(menuIndex)}
                                        />
                                        <label htmlFor={`menu-${menu.menu_id}`}>
                                            <i className={`bi ${menu.icon} menu-icon`}></i>
                                            <div className="menu-label-content">
                                                <span className="menu-title">{menu.name}</span>
                                                <span className="menu-description">
                                                    {getMenuDescription(menu.name)}
                                                </span>
                                            </div>
                                        </label>
                                    </div>
                                    {menu.submenu && (
                                        <div className="permissions-submenu">
                                            {menu.submenu.map((submenu, submenuIndex) => (
                                                <div key={submenuIndex} className="permissions-submenu-item">
                                                    <input
                                                        type="checkbox"
                                                        className="styled-checkbox"
                                                        id={`menu-${submenu.menu_id}`}
                                                        checked={permissions[submenu.menu_id] || false}
                                                        onChange={() => handleSubmenuChange(menuIndex, submenuIndex)}
                                                    />
                                                    <label htmlFor={`menu-${submenu.menu_id}`}>
                                                        <i className={`bi ${submenu.icon} menu-icon`}></i>
                                                        <span>{submenu.name}</span>
                                                    </label>
                                                </div>
                                            ))}
                                        </div>
                                    )}
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default Permissions;